import React from "react";

import ObjetivoV2AccordionCard from "./ObjetivoV2AccordionCard";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

const MODOS_HISTORICO_CLIENTES = [
  {
    value: "TODOS",
    label: "Todos os clientes",
  },
  {
    value: "SEM_COMPRAS_SUBMARCAS",
    label: "Sem compras das submarcas no período histórico",
  },
];

export default function ObjetivoV2HistoricoClientes({
  form,
  setForm,
  submarcasHistorico,
  setSubmarcasHistorico,
  submarcasHistoricoOpcoes,
  submarcaHistoricoTermo,
  setSubmarcaHistoricoTermo,
  loadingSubmarcasHistorico,
  pesquisarSubmarcasHistorico,
  setSubmarcasHistoricoOpcoes,
}) {
  const modoHistoricoSelecionado =
    MODOS_HISTORICO_CLIENTES.find((x) => x.value === form.clientes_historico_modo) ||
    MODOS_HISTORICO_CLIENTES[0];

  return (
    <ObjetivoV2AccordionCard titulo="Histórico de clientes">
      <MDBox
        display="grid"
        gridTemplateColumns={{
          xs: "1fr",
          md:
            form.clientes_historico_modo === "SEM_COMPRAS_SUBMARCAS"
              ? "minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr)"
              : "minmax(0, 1fr)",
        }}
        gap={2}
        alignItems="start"
      >
        <MDBox>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Regra do histórico
          </MDTypography>

          <Autocomplete
            size="small"
            options={MODOS_HISTORICO_CLIENTES}
            getOptionLabel={(option) => option?.label || ""}
            value={modoHistoricoSelecionado}
            onChange={(_, value) =>
              setForm((prev) => ({
                ...prev,
                clientes_historico_modo: value?.value || "TODOS",

                clientes_historico_dataini:
                  value?.value === "SEM_COMPRAS_SUBMARCAS" ? prev.clientes_historico_dataini : "",

                clientes_historico_datafim:
                  value?.value === "SEM_COMPRAS_SUBMARCAS" ? prev.clientes_historico_datafim : "",
              }))
            }
            isOptionEqualToValue={(option, value) => option?.value === value?.value}
            disableClearable
            renderInput={(params) => <TextField {...params} placeholder="Selecione..." />}
          />
        </MDBox>

        {form.clientes_historico_modo === "SEM_COMPRAS_SUBMARCAS" && (
          <>
            <MDBox>
              <MDTypography variant="caption" color="text" display="block" mb={0.5}>
                Histórico desde
              </MDTypography>

              <MDInput
                type="date"
                fullWidth
                value={form.clientes_historico_dataini}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    clientes_historico_dataini: e.target.value,
                  }))
                }
              />
            </MDBox>

            <MDBox>
              <MDTypography variant="caption" color="text" display="block" mb={0.5}>
                Histórico até
              </MDTypography>

              <MDInput
                type="date"
                fullWidth
                value={form.clientes_historico_datafim}
                onChange={(e) =>
                  setForm((prev) => ({
                    ...prev,
                    clientes_historico_datafim: e.target.value,
                  }))
                }
              />
            </MDBox>
          </>
        )}
      </MDBox>

      {form.clientes_historico_modo === "SEM_COMPRAS_SUBMARCAS" && (
        <MDBox mt={2}>
          <MDTypography variant="caption" color="text" display="block" mb={0.5}>
            Submarcas do histórico
          </MDTypography>

          <Autocomplete
            multiple
            size="small"
            options={submarcasHistoricoOpcoes}
            loading={loadingSubmarcasHistorico}
            filterOptions={(options) => options}
            getOptionLabel={(option) => {
              const ref = String(option?.ref || option?.refsubmarca || "").trim();
              const nome = String(option?.nome || option?.submarca || "").trim();

              return nome ? `${ref} - ${nome}` : ref;
            }}
            value={submarcasHistorico.map((item) => ({
              ref: item?.refsubmarca || item?.ref || "",
              nome: item?.submarca || item?.nome || "",
            }))}
            inputValue={submarcaHistoricoTermo}
            onInputChange={(_, value, reason) => {
              if (reason === "input") {
                setSubmarcaHistoricoTermo(value);
                pesquisarSubmarcasHistorico(value);
              }

              if (reason === "clear") {
                setSubmarcaHistoricoTermo("");
                setSubmarcasHistoricoOpcoes([]);
              }
            }}
            onChange={(_, values) => {
              setSubmarcasHistorico(
                values.map((item) => ({
                  refsubmarca: String(item?.ref || item?.refsubmarca || "").trim(),
                  submarca: String(item?.nome || item?.submarca || "").trim(),
                }))
              );
            }}
            isOptionEqualToValue={(option, value) =>
              String(option?.ref || option?.refsubmarca || "") ===
              String(value?.ref || value?.refsubmarca || "")
            }
            disableCloseOnSelect
            noOptionsText={
              submarcaHistoricoTermo.length < 2
                ? "Escreve pelo menos 2 caracteres."
                : "Nenhuma submarca encontrada."
            }
            renderInput={(params) => <TextField {...params} placeholder="Pesquisar submarca..." />}
          />

          <MDTypography variant="caption" color="text" display="block" mt={1.5}>
            Serão excluídos os clientes com compras líquidas positivas das submarcas selecionadas
            durante este período.
          </MDTypography>
        </MDBox>
      )}
    </ObjetivoV2AccordionCard>
  );
}
